import { initializeApp } from "@angular/fire/app";

export class BaseEntity {
    public key?: string;    
    public createdAt!: Date;
    public updatedAt!: Date;
}